import { render, staticRenderFns } from "./DestinationPlanningCard.vue?vue&type=template&id=8f34484c"
import script from "./DestinationPlanningCard.vue?vue&type=script&lang=ts"
export * from "./DestinationPlanningCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports